import { UserProfile } from '../types';

const WATEEN_USER_KEY = 'wateen_user_session';
const WATEEN_SETTINGS_KEY = 'wateen_app_settings';

export interface AppSettings {
  theme: 'dark' | 'light' | 'midnight' | 'cyber' | 'royal_gold' | 'cosmic_nebula' | 'neon_emerald' | 'dark_diamond';
  soundEnabled: boolean;
  hapticsEnabled: boolean;
  language: 'ar' | 'en';
}

export function getLocalUser(): UserProfile | null {
  try {
    const raw = localStorage.getItem(WATEEN_USER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.username) return null;

    const username = String(parsed.username).toLowerCase().replace(/^@/, '');
    const displayName = parsed.displayName || parsed.name || username || 'مستخدم وتين';

    const repairedUser: UserProfile = {
      id: parsed.id || `user_${username}`,
      username,
      displayName,
      email: parsed.email || `${username}@wateen.app`,
      phone: parsed.phone,
      avatar: parsed.avatar || `https://api.dicebear.com/7.x/bottts/svg?seed=${username}`,
      bio: parsed.bio || 'مرحباً بك في وتين ✨',
      birthDate: parsed.birthDate,
      country: parsed.country || 'العالم العربي',
      language: parsed.language === 'en' ? 'en' : 'ar',
      isVerified: parsed.isVerified ?? true,
      isAdmin: Boolean(
        parsed.isAdmin ||
        parsed.role === 'admin' ||
        username === 'aymen' ||
        username === 'admin' ||
        (parsed.email && parsed.email.toLowerCase().includes('aymenansta7'))
      ),
      isBanned: parsed.isBanned ?? false,
      pulseStatus: parsed.pulseStatus && typeof parsed.pulseStatus === 'object' && parsed.pulseStatus.state
        ? parsed.pulseStatus
        : { state: 'available', emoji: '✨', text: 'متاح للحديث' },
      profileTheme: parsed.profileTheme || 'emerald',
      joinedDate: parsed.joinedDate || Date.now(),
      activeSessions: Array.isArray(parsed.activeSessions) ? parsed.activeSessions : [],
      privacy: parsed.privacy && typeof parsed.privacy === 'object'
        ? {
            lastSeen: parsed.privacy.lastSeen || 'everyone',
            readReceipts: parsed.privacy.readReceipts ?? true,
            whoCanCall: parsed.privacy.whoCanCall || 'everyone',
            whoCanMessage: parsed.privacy.whoCanMessage || 'everyone',
            phoneVisibility: parsed.privacy.phoneVisibility || 'nobody',
            emailVisibility: parsed.privacy.emailVisibility || 'nobody',
            twoFactorEnabled: parsed.privacy.twoFactorEnabled ?? false,
          }
        : {
            lastSeen: 'everyone',
            readReceipts: true,
            whoCanCall: 'everyone',
            whoCanMessage: 'everyone',
            phoneVisibility: 'nobody',
            emailVisibility: 'nobody',
            twoFactorEnabled: false,
          },
      circles: parsed.circles || {},
      blockedUsers: Array.isArray(parsed.blockedUsers) ? parsed.blockedUsers : [],
      isPremium: parsed.isPremium ?? false,
      subscription: parsed.subscription,
      chatBubbleStyle: parsed.chatBubbleStyle || 'default',
      profileBanner: parsed.profileBanner,
    };

    return repairedUser;
  } catch {
    return null;
  }
}

export function setLocalUser(user: UserProfile | null) {
  try {
    if (user) {
      localStorage.setItem(WATEEN_USER_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(WATEEN_USER_KEY);
    }
  } catch {
    // ignore
  }
}

export function getLocalSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(WATEEN_SETTINGS_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // ignore
  }
  return {
    theme: 'dark',
    soundEnabled: true,
    hapticsEnabled: true,
    language: 'ar',
  };
}

export function setLocalSettings(settings: AppSettings) {
  try {
    localStorage.setItem(WATEEN_SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    // ignore
  }
}
